/**
 * @generated SignedSource<<581103277ce61bace9b4536fca5a026e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CBPayAssetFilters = {
  networks?: ReadonlyArray<string> | null;
  tickers?: ReadonlyArray<string> | null;
};
export type BuySelectAssetPageDataProviderQuery$variables = {
  buys: boolean;
  filter: CBPayAssetFilters;
  inWebView: boolean;
  sends: boolean;
  skipDepositInformation: boolean;
};
export type BuySelectAssetPageDataProviderQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"AssetListFragment" | "PolicyRestrictionsGuardFragment" | "useNewSourcesOfFundsFragment" | "useRunChecksAgainstAssetListFragment" | "useSelectAssetTabsFragment">;
  };
};
export type BuySelectAssetPageDataProviderQuery = {
  response: BuySelectAssetPageDataProviderQuery$data;
  variables: BuySelectAssetPageDataProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "buys"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "inWebView"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sends"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipDepositInformation"
},
v5 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Amount",
  "kind": "LinkedField",
  "name": "availableBalance",
  "plural": false,
  "selections": [
    (v12/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v15 = [
  (v12/*: any*/),
  (v14/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetBalanceBreakdown",
  "kind": "LinkedField",
  "name": "assetBalanceBreakdown",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Amount",
      "kind": "LinkedField",
      "name": "availableToSendBalance",
      "plural": false,
      "selections": (v15/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Amount",
      "kind": "LinkedField",
      "name": "availableToSendBalanceFiat",
      "plural": false,
      "selections": (v15/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v19 = [
  (v8/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "assetOrFiatCurrency",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v11/*: any*/),
        (v16/*: any*/),
        (v8/*: any*/),
        (v7/*: any*/),
        (v6/*: any*/)
      ],
      "type": "TiersCurrency",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v16/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "asset",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v17/*: any*/),
            (v7/*: any*/),
            (v18/*: any*/),
            (v8/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "ViewerAsset",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v19/*: any*/),
      "type": "Node",
      "abstractKey": "__isNode"
    },
    {
      "kind": "InlineFragment",
      "selections": (v19/*: any*/),
      "type": "ViewerEquity",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEnabled",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "PaymentMethodV2",
  "kind": "LinkedField",
  "name": "paymentMethod",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "instantBuy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "pickerData",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "use3ds",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "institutionName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cardLast4",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requires3dsDdc",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expiresAt",
              "storageKey": null
            }
          ],
          "type": "WorldpayCardPickerData",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accountName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accountNumber",
              "storageKey": null
            }
          ],
          "type": "BankPickerDataV2",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PaymentMethodFiatAccount",
              "kind": "LinkedField",
              "name": "fiatAccount",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v8/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "CoinbaseFiatAccountPickerData",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    (v9/*: any*/),
    (v7/*: any*/),
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentLimits",
      "kind": "LinkedField",
      "name": "limits",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Amount",
          "kind": "LinkedField",
          "name": "remainingAvailableLimit",
          "plural": false,
          "selections": (v15/*: any*/),
          "storageKey": null
        },
        (v22/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "paymentMethodName",
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeAllowance",
      "kind": "LinkedField",
      "name": "tradeCapabilities",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowBuy",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryBuy",
      "storageKey": null
    },
    (v8/*: any*/)
  ],
  "storageKey": null
},
v24 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "restrictionName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Link",
    "kind": "LinkedField",
    "name": "link",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v22/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  },
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BuySelectAssetPageDataProviderQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Viewer",
          "kind": "LinkedField",
          "name": "viewer",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "skipDepositInformation",
                  "variableName": "skipDepositInformation"
                }
              ],
              "kind": "FragmentSpread",
              "name": "useNewSourcesOfFundsFragment"
            },
            {
              "args": (v5/*: any*/),
              "kind": "FragmentSpread",
              "name": "AssetListFragment"
            },
            {
              "args": (v5/*: any*/),
              "kind": "FragmentSpread",
              "name": "useSelectAssetTabsFragment"
            },
            {
              "args": (v5/*: any*/),
              "kind": "FragmentSpread",
              "name": "useRunChecksAgainstAssetListFragment"
            },
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "buys",
                  "variableName": "buys"
                },
                {
                  "kind": "Variable",
                  "name": "inWebView",
                  "variableName": "inWebView"
                },
                {
                  "kind": "Variable",
                  "name": "sends",
                  "variableName": "sends"
                }
              ],
              "kind": "FragmentSpread",
              "name": "PolicyRestrictionsGuardFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW",
        "path": "viewer"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "BuySelectAssetPageDataProviderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProperties",
            "kind": "LinkedField",
            "name": "userProperties",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Country",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showInstantAchUx",
                "storageKey": null
              },
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "supportedSourcesOfFunds",
                "value": [
                  "PAYMENT_METHOD",
                  "FIAT_WALLET",
                  "CRYPTO_ACCOUNT"
                ]
              }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "cbPaySourcesOfFunds",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v13/*: any*/),
                      (v20/*: any*/),
                      (v9/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Amount",
                    "kind": "LinkedField",
                    "name": "remainingAvailableLimit",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "CBPaySourceOfFundsCryptoAccount",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v21/*: any*/),
                  (v23/*: any*/)
                ],
                "type": "CBPaySourceOfFundsPaymentMethod",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v13/*: any*/),
                      (v20/*: any*/),
                      (v9/*: any*/),
                      (v7/*: any*/),
                      {
                        "condition": "skipDepositInformation",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AccountDepositInformation",
                            "kind": "LinkedField",
                            "name": "depositInformation",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isDepositAllowed",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "depositCurrency",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AccountDepositMethod",
                                "kind": "LinkedField",
                                "name": "availableDepositMethods",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isActive",
                                    "storageKey": null
                                  },
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AccountDepositMethodInformation",
                                    "kind": "LinkedField",
                                    "name": "depositInformation",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "key",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "title",
                                        "storageKey": null
                                      },
                                      (v14/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v23/*: any*/)
                ],
                "type": "CBPaySourceOfFundsFiatWallet",
                "abstractKey": null
              }
            ],
            "storageKey": "cbPaySourcesOfFunds(supportedSourcesOfFunds:[\"PAYMENT_METHOD\",\"FIAT_WALLET\",\"CRYPTO_ACCOUNT\"])"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountConnection",
            "kind": "LinkedField",
            "name": "accountsV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v13/*: any*/),
                      (v20/*: any*/),
                      (v9/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Amount",
                        "kind": "LinkedField",
                        "name": "availableBalanceInNativeCurrency",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "primary",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "CbPayAssetConnection",
            "kind": "LinkedField",
            "name": "cbPayTradableAssets",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CBPayAssetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CBPayAsset",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v7/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "exponent",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NetworkMetadata",
                        "kind": "LinkedField",
                        "name": "networks",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minSend",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isDefault",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "quoteCurrency",
                            "value": "USD"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "marketCap",
                        "storageKey": "marketCap(quoteCurrency:\"USD\")"
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "condition": "inWebView",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isWebview2faEligible",
                "storageKey": null
              }
            ]
          },
          {
            "condition": "sends",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "sendRestrictions",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "sends"
                  }
                ],
                "concreteType": "PolicyRestriction",
                "kind": "LinkedField",
                "name": "policyRestrictions",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": "policyRestrictions(action:\"sends\")"
              }
            ]
          },
          {
            "condition": "buys",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "buyRestrictions",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "buys"
                  }
                ],
                "concreteType": "PolicyRestriction",
                "kind": "LinkedField",
                "name": "policyRestrictions",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": "policyRestrictions(action:\"buys\")"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "84cf6ad7a3294707459c5d3b57657069",
    "id": null,
    "metadata": {},
    "name": "BuySelectAssetPageDataProviderQuery",
    "operationKind": "query",
    "text": "query BuySelectAssetPageDataProviderQuery(\n  $filter: CBPayAssetFilters!\n  $sends: Boolean!\n  $buys: Boolean!\n  $inWebView: Boolean!\n  $skipDepositInformation: Boolean!\n) {\n  viewer {\n    ...useNewSourcesOfFundsFragment_4pQBtl\n    ...AssetListFragment_Vt7Yj\n    ...useSelectAssetTabsFragment_Vt7Yj\n    ...useRunChecksAgainstAssetListFragment_Vt7Yj\n    ...PolicyRestrictionsGuardFragment_KfpDY\n    id\n  }\n}\n\nfragment AssetListCellFragment on CBPayAsset {\n  uuid\n  name\n  symbol\n  imageUrl\n}\n\nfragment AssetListFragment_Vt7Yj on Viewer {\n  cbPayTradableAssets(filter: $filter) {\n    edges {\n      node {\n        ...AssetListCellFragment\n        ...readCBPayAssetAsOnrampStateFragment\n        ...reduceCBPayAssetsBySearchTermFragment\n        ...useFilterCBPayAssetsByDestinationWalletsFragment\n        ...readCBPayAssetUuidFragment\n        uuid\n        symbol\n        marketCap(quoteCurrency: \"USD\")\n        id\n      }\n    }\n  }\n  accountsV2 {\n    edges {\n      node {\n        ...filterCryptoAccountsByBalanceFragment\n        ...readAccountViewerAssetUuidFragment\n        ...CryptoAccountListCellFragment\n        uuid\n        primary\n        availableBalanceInNativeCurrency {\n          value\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment CryptoAccountListCellFragment on Account {\n  ...readAccountBalanceFragment\n  ...readAccountBalanceFiatFragment\n  name\n  assetOrFiatCurrency {\n    __typename\n    ... on ViewerAsset {\n      asset {\n        uuid\n        symbol\n        name\n        imageUrl\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on TiersCurrency {\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment PolicyRestrictionsGuardFragment_KfpDY on Viewer {\n  userProperties {\n    uuid\n    country {\n      code\n      name\n    }\n    id\n  }\n  isWebview2faEligible @include(if: $inWebView)\n  sendRestrictions: policyRestrictions(action: sends) @include(if: $sends) {\n    restrictionName\n    link {\n      url\n      text\n    }\n    description\n    message\n    id\n  }\n  buyRestrictions: policyRestrictions(action: buys) @include(if: $buys) {\n    restrictionName\n    link {\n      url\n      text\n    }\n    description\n    message\n    id\n  }\n}\n\nfragment filterCryptoAccountsByBalanceFragment on Account {\n  type\n  availableBalanceInNativeCurrency {\n    value\n  }\n  assetOrFiatCurrency {\n    __typename\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on TiersCurrency {\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment getIsCountryAllowedAccountFragment on Account {\n  type\n}\n\nfragment getIsCountryAllowedFiatFragment on PaymentMethodV2 {\n  type\n  instantBuy\n  pickerData {\n    __typename\n    ... on WorldpayCardPickerData {\n      use3ds\n    }\n    ... on BankPickerDataV2 {\n      __typename\n    }\n  }\n}\n\nfragment readAccountBalanceFiatFragment on Account {\n  assetOrFiatCurrency {\n    __typename\n    ... on TiersCurrency {\n      assetBalanceBreakdown {\n        availableToSendBalanceFiat {\n          currency\n          value\n        }\n      }\n      id\n    }\n    ... on ViewerAsset {\n      assetBalanceBreakdown {\n        availableToSendBalanceFiat {\n          currency\n          value\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readAccountBalanceFragment on Account {\n  availableBalance {\n    currency\n  }\n  assetOrFiatCurrency {\n    __typename\n    ... on TiersCurrency {\n      type\n      assetBalanceBreakdown {\n        availableToSendBalance {\n          currency\n          value\n        }\n      }\n      id\n    }\n    ... on ViewerAsset {\n      assetBalanceBreakdown {\n        availableToSendBalance {\n          currency\n          value\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readAccountViewerAssetUuidFragment on Account {\n  assetOrFiatCurrency {\n    __typename\n    ... on ViewerAsset {\n      asset {\n        uuid\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on TiersCurrency {\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readCBPayAssetAsOnrampStateFragment on CBPayAsset {\n  uuid\n  symbol\n  imageUrl\n  name\n  exponent\n  networks {\n    name\n    displayName\n    minSend\n    isDefault\n  }\n}\n\nfragment readCBPayAssetUuidFragment on CBPayAsset {\n  uuid\n}\n\nfragment readCryptoAccountFragment on Account {\n  ...getIsCountryAllowedAccountFragment\n  ...readAccountBalanceFragment\n  ...readAccountBalanceFiatFragment\n  uuid\n  name\n  assetOrFiatCurrency {\n    __typename\n    ... on ViewerAsset {\n      asset {\n        uuid\n        symbol\n        name\n        imageUrl\n        id\n      }\n    }\n    ... on TiersCurrency {\n      name\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readCryptoAccountsFragment on Account {\n  ...readCryptoAccountFragment\n}\n\nfragment readDepositInformationFragment on Account {\n  depositInformation {\n    isDepositAllowed\n    depositCurrency\n    availableDepositMethods {\n      isActive\n      type\n      depositInformation {\n        key\n        title\n        value\n      }\n    }\n  }\n}\n\nfragment readFiatWalletAccountFragment on Account {\n  ...getIsCountryAllowedAccountFragment\n  ...readAccountBalanceFragment\n  uuid\n  name\n  type\n  assetOrFiatCurrency {\n    __typename\n    ... on TiersCurrency {\n      code\n      name\n      type\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readFiatWalletPaymentMethodFragment on PaymentMethodV2 {\n  uuid\n  name\n  type\n  currency\n  pickerData {\n    __typename\n    ... on CoinbaseFiatAccountPickerData {\n      fiatAccount {\n        uuid\n        id\n      }\n    }\n  }\n  limits {\n    remainingAvailableLimit {\n      currency\n      value\n    }\n  }\n}\n\nfragment readFiatWalletsAccountFragment on Account {\n  ...readFiatWalletAccountFragment\n  uuid\n  type\n}\n\nfragment readFiatWalletsPaymentMethodFragment on PaymentMethodV2 {\n  ...readFiatWalletPaymentMethodFragment\n  uuid\n  type\n  pickerData {\n    __typename\n    ... on CoinbaseFiatAccountPickerData {\n      fiatAccount {\n        uuid\n        id\n      }\n    }\n  }\n}\n\nfragment readPaymentMethodFragment on PaymentMethodV2 {\n  ...getIsCountryAllowedFiatFragment\n  uuid\n  type\n  paymentMethodName: name\n  currency\n  verified\n  tradeCapabilities {\n    allowBuy\n  }\n  pickerData {\n    __typename\n    ... on BankPickerDataV2 {\n      accountName\n      accountNumber\n    }\n    ... on WorldpayCardPickerData {\n      institutionName\n      bin\n      cardLast4\n      use3ds\n      requires3dsDdc\n      expiresAt\n    }\n    ... on CoinbaseFiatAccountPickerData {\n      __typename\n    }\n  }\n  limits {\n    remainingAvailableLimit {\n      currency\n      value\n    }\n    description\n  }\n}\n\nfragment readPaymentMethodsFragment on PaymentMethodV2 {\n  ...readPaymentMethodFragment\n  uuid\n  primaryBuy\n}\n\nfragment reduceCBPayAssetsBySearchTermFragment on CBPayAsset {\n  symbol\n  name\n}\n\nfragment useFilterCBPayAssetsByDestinationWalletsFragment on CBPayAsset {\n  uuid\n  symbol\n  networks {\n    name\n  }\n}\n\nfragment useNewSourcesOfFundsFragment_4pQBtl on Viewer {\n  ...useSourceOfFundsToCommonFormatRequiredData\n  cbPaySourcesOfFunds(supportedSourcesOfFunds: [\"PAYMENT_METHOD\", \"FIAT_WALLET\", \"CRYPTO_ACCOUNT\"]) {\n    __typename\n    ... on CBPaySourceOfFundsCryptoAccount {\n      account {\n        ...useParseSourcesOfFundsAccountFragment\n        id\n      }\n      remainingAvailableLimit {\n        value\n        currency\n      }\n    }\n    ... on CBPaySourceOfFundsPaymentMethod {\n      isEnabled\n      paymentMethod {\n        ...useParseSourcesOfFundsPaymentMethodFragment\n        pickerData {\n          __typename\n        }\n        id\n      }\n    }\n    ... on CBPaySourceOfFundsFiatWallet {\n      isEnabled\n      account {\n        ...useParseSourcesOfFundsAccountFragment\n        ...useParseSourcesOfFundsAccountDepositInformationFragment @skip(if: $skipDepositInformation)\n        id\n      }\n      paymentMethod {\n        ...useParseSourcesOfFundsPaymentMethodFragment\n        id\n      }\n    }\n  }\n  accountsV2 {\n    edges {\n      node {\n        ...useParseSourcesOfFundsAccountFragment\n        id\n      }\n    }\n  }\n}\n\nfragment useParseSourcesOfFundsAccountDepositInformationFragment on Account {\n  ...readDepositInformationFragment\n}\n\nfragment useParseSourcesOfFundsAccountFragment on Account {\n  ...getIsCountryAllowedAccountFragment\n  ...readCryptoAccountsFragment\n  ...readFiatWalletsAccountFragment\n}\n\nfragment useParseSourcesOfFundsPaymentMethodFragment on PaymentMethodV2 {\n  ...getIsCountryAllowedFiatFragment\n  ...readFiatWalletsPaymentMethodFragment\n  ...readPaymentMethodsFragment\n}\n\nfragment useRunChecksAgainstAssetListFragment_Vt7Yj on Viewer {\n  cbPayTradableAssets(filter: $filter) {\n    edges {\n      node {\n        ...useFilterCBPayAssetsByDestinationWalletsFragment\n        ...readCBPayAssetAsOnrampStateFragment\n        id\n      }\n    }\n  }\n}\n\nfragment useSelectAssetTabsFragment_Vt7Yj on Viewer {\n  cbPayTradableAssets(filter: $filter) {\n    edges {\n      node {\n        ...readCBPayAssetUuidFragment\n        id\n      }\n    }\n  }\n  accountsV2 {\n    edges {\n      node {\n        ...filterCryptoAccountsByBalanceFragment\n        ...readAccountViewerAssetUuidFragment\n        id\n      }\n    }\n  }\n}\n\nfragment useSourceOfFundsToCommonFormatRequiredData on Viewer {\n  userProperties {\n    country {\n      code\n    }\n    showInstantAchUx\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ef224e8d5c5819dc240c606293d7f212";

export default node;
